/* ============
 * Mutations for the filters module
 * ============
 *
 */
import clone from 'lodash/clone';
import { ADD, CLEAR, LOAD } from './mutation-types';

/* eslint-disable no-param-reassign */
export default {
  [LOAD](state, filters) {
    state.filters = filters.data.sort((filter1, filter2) => filter1.position - filter2.position);
  },
  [ADD](state, filter) {
    let activeFilter = state.activeFilters.find(({ key }) => key === filter.key);

    if (!activeFilter) {
      activeFilter = clone(filter);
      state.activeFilters.push(activeFilter);
    }

    if (filter.value.length === filter.options.length ||
      (Array.isArray(activeFilter.value) && filter.value.length === 0)) {
      state.activeFilters.splice(state.activeFilters.indexOf(activeFilter), 1);
    } else {
      activeFilter.value = Array.isArray(activeFilter.value)
        ? filter.value.slice()
        : filter.value;
    }
  },
  [CLEAR](state) {
    state.activeFilters = [];
  },
};
